module.exports = __webpack_public_path__ + "static/media/1009868.ee3b9e5f.jpg";